// @core/api/endpoints/platform/grant_data_consent.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ConsentRecordResponse,
  GrantDataConsentRequest,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Grant data consent
 * Records user consent for cross-border data sharing with a specific federation peer. Required for GDPR/152-FZ compliance.
 */
export async function GrantDataConsent(
  data: GrantDataConsentRequest,
  options?: RequestOptions
): Promise<ConsentRecordResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/federation/consent`;
  const requestOptions = options;
  return client.post<ConsentRecordResponse>(requestPath, data, requestOptions);
}
